import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rowsPerPageLabel: {
    id: 'react-components.VCZBMt',
    defaultMessage: 'Rows per page',
  },
  allRowsLabel: {
    id: 'react-components.zQvVDJ',
    defaultMessage: 'All',
  },
  previousPageLabel: {
    id: 'react-components.JJNc3c',
    defaultMessage: 'Previous',
  },
  nextPageLabel: {
    id: 'react-components.9+Ddtu',
    defaultMessage: 'Next',
  },
});
